import { __extends } from 'tslib';
import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-view.css';
var getClassNameList = classNames.bind(styles);
var UitkView = /** @class */function (_super) {
  __extends(UitkView, _super);
  function UitkView() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  UitkView.prototype.render = function () {
    var _a = this.props,
      children = _a.children,
      className = _a.className;
    var cssClassNames = getClassNameList('uitk-view', className);
    return React.createElement("div", {
      className: cssClassNames
    }, children);
  };
  UitkView.displayName = 'UitkView';
  return UitkView;
}(React.PureComponent);
export { UitkView };